const initialState = {
  isLoading: false,
  tasks: [],
  metadata: {},
  error: null,
};

export const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCHING_TASKS':
      return {
        ...state,
        isLoading: true,
      };
    case 'UPDATING_TASKS':
      return {
        ...state,
        isUpdating: true,
      };
    case 'SET_TASKS':
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        tasks: action.payload.taskDetails,
        metadata: action.payload.metadata,
      };
    case 'FETCH_TASKS_ERROR':
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        error: action.error,
      };
    default:
      return state;
  }
};
